import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dropdown-trigger" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  class: "dropdown-menu",
  id: "dropdown-menu",
  role: "menu"
}
const _hoisted_4 = { class: "dropdown-content" }

import { ref } from "vue";
import VglistUtils from "../utils";

interface Props {
  gameId: number;
  chevronDownIcon: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'game-card-dropdown',
  props: {
    gameId: {},
    chevronDownIcon: {}
  },
  setup(__props: any) {

const props = __props;

const isActive = ref(false);
const favorited = ref(false);
const hasCheckedFavorited = ref(false);

function onClick(event: Event) {
  if (!hasCheckedFavorited.value) {
    // Check whether the user has favorited the game before rendering the
    // dropdown buttons.
    VglistUtils.authenticatedFetch(`/games/${props.gameId}/favorited.json`, "GET").then(
      (parsedJson) => {
        if (parsedJson === true || parsedJson === false) {
          favorited.value = parsedJson;
        }
        isActive.value = true;
        closeDropdownOnClick();
        hasCheckedFavorited.value = true;
      }
    );
  } else {
    isActive.value = true;
    closeDropdownOnClick();
  }
}

function closeDropdownOnClick() {
  // Close the dropdown if the user clicks outside the dropdown.
  document.addEventListener("click", (event) => {
    // If the user is clicking on something other than an element, return early.
    if (!(event.target instanceof Element) && !(event.target instanceof HTMLDocument)) {
      return;
    }
    // If the user clicks on the dropdown itself, don't close the dropdown.
    if ((event.target as Element).closest(".dropdown-dynamic")) {
      return;
    }
    isActive.value = false;
  });
}

function favoriteGame() {
  VglistUtils.rawAuthenticatedFetch(`/games/${props.gameId}/favorite.json`, "POST").then(
    (response) => {
      if (response.ok) {
        favorited.value = true;
      }
    }
  );
}

function unfavoriteGame() {
  VglistUtils.rawAuthenticatedFetch(`/games/${props.gameId}/unfavorite.json`, "DELETE").then(
    (response) => {
      if (response.ok) {
        favorited.value = false;
      }
    }
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown dropdown-dynamic game-card-dropdown is-right", { 'is-active': isActive.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "button is-borderless is-shadowless",
        "aria-haspopup": "true",
        "aria-controls": "dropdown-menu",
        onClick: onClick
      }, [
        _createElementVNode("span", {
          class: "icon",
          innerHTML: __props.chevronDownIcon
        }, null, 8, _hoisted_2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!favorited.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "dropdown-item",
              onClick: favoriteGame
            }, " Favorite "))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "dropdown-item",
              onClick: unfavoriteGame
            }, " Unfavorite "))
      ])
    ])
  ], 2))
}
}

})